<template>
    <div>
        <a-page-header
        class="header_title"
        title="Products listing"
        @back="() => $router.go(-1)"
        />
        <!-- <a-divider orientation="left">Products listing</a-divider> -->
        <a-row>
            <a-col :span="6">
                <img alt="image" 
                    :src="img"
                    style="width:150px;"/>
            </a-col>
            <a-col :span="18">
                <table style="width:100%;">
                    <tr>
                        <td><p style="font-size: 23px;">{{title}}</p></td>
                    </tr>
                    <tr>
                        <td><a-button style="width:85px;margin-bottom:10px;" :class="{'ant-btn-danger':isActive=='eBay'}" @click="action_tab($event,'eBay')">eBay</a-button>
                        <a-button style="width:85px;margin-left:10px;margin-bottom:10px;" :class="{'ant-btn-danger':isActive=='shopify'}" @click="action_tab($event,'shopify')">shopify</a-button></td>
                    </tr>
                   <tr>
                        <td><a-button style="width:85px;" :class="{'ant-btn-danger':isActive=='Amazon'}" @click="action_tab($event,'Amazon')">Amazon</a-button>
                        <a-button style="width:85px;margin-left:10px;" :class="{'ant-btn-danger':isActive=='walmart'}" @click="action_tab($event,'walmart')">walmart</a-button></td>
                   </tr>
                </table>
            </a-col>
        </a-row>
        <div style="width:100%;height:20px;"></div>
        <!-- <a-row>
            <a-col :span="12"> -->
                <a-table :columns="columns" :data-source="data_1" size="small" rowKey="id" :pagination='pagination_1' @change="tableChange_1">
                    <a class='str1' slot="str1" slot-scope="text">{{ text }}</a>
                    <a class='str2' slot="str2" slot-scope="text">{{ text }}</a>

                    <a slot="str3" slot-scope="text" :href="text[1]" target="_blank">{{ text[0] }}</a>

                    <span slot="tags" slot-scope="tags">
                        <!-- <a-tag>
                            <span class='item_span'>L:</span>{{ tags[0].toUpperCase() }}
                        </a-tag> -->
                        <!-- <div class="line_div"></div> -->
                        <!-- <a-tag>
                            <span class='item_span'>D:</span>{{ tags[1].toUpperCase() }}
                        </a-tag> -->
                        <a-tag>
                            <span class='item_span'>{{tags[0]}}</span>
                        </a-tag>
                    </span>
                </a-table>
            <!-- </a-col>
            <a-col :span="12">
                <a-table :columns="columns" :data-source="data_2" size="small" rowKey="id" :pagination='pagination_2' @change="tableChange_2">
                    <a class='str1' slot="str1" slot-scope="text">{{ text }}</a>
                    <a class='str2' slot="str2" slot-scope="text">{{ text }}</a>

                    <a slot="str3" slot-scope="text">{{ text }}</a>
                    <span slot="tags" slot-scope="tags">
                        <a-tag>
                            <span class='item_span'>L:</span>{{ tags[0].toUpperCase() }}
                        </a-tag>
                        <div class="line_div"></div>
                        <a-tag>
                            <span class='item_span'>D:</span>{{ tags[1].toUpperCase() }}
                        </a-tag>
                    </span>
                </a-table>
            </a-col>
        </a-row> -->

    </div>
</template>

<script>
import {getProductSalesSummary,getProductDetail} from '@/network/prorequest';
import {getEBadyProductSalesSummary} from '@/network/productSalesSummary';
import {getProducts} from '@/network/navigation';

const columns = [
  {
    title: 'hit count',
    dataIndex: 'hitCount',
    key: 'hitCount',
    scopedSlots: { customRender: 'str1' },
  },
  {
    title: 'quantity sold',
    dataIndex: 'quantitySold',
    key: 'quantitySold',
    scopedSlots: { customRender: 'str2' },
  },
  {
    title: 'account',
    dataIndex: 'account',
    key: 'account',
    scopedSlots: { customRender: 'str3' },
  },
  {
    title: 'start date',
    key: 'startDate',
    dataIndex: 'startDate',
  },
  {
    title: 'price',
    key: 'str5',
    dataIndex: 'str5',
    scopedSlots: { customRender: 'tags' },
  },
];
const data_1 = [];
const data_2 = [];
// for (let i = 0; i < 60; i++) {
//   data_1.push({
//     id:i,
//     str1: 10000+i,
//     str2: 200,
//     str3: 'test9999',
//     str4: '2021-06-25',
//     str5: ['[30.00 AUD - 35.00 AUD]', '[8.00 AUD | 9.00 AUD]'],
//   });
//     data_2.push({
//     id:i,
//     str1: 10000+i,
//     str2: 200,
//     str3: 'test9999',
//     str4: '2021-06-25',
//     str5: ['[30.00 AUD - 35.00 AUD]', '[8.00 AUD | 9.00 AUD]'],
//   });
// }
export default {
    name: 'NodeprojectStores',
    components: {  },
    directives: {  },
    data() {
        return {
            isActive:'eBay',
            pagination_1:{
                current:1,
                defaultCurrent:1,
                defaultPageSize:18,
                total:0
            },
            pagination_2:{
                current:2,
                defaultCurrent:2,
                defaultPageSize:18,
                total:0
            },
            data_1,
            columns,
            data_2,
            img:'',
            title:'',
            dara_productCode:'',
        };
    },
    created(){
        // var product_id = this.$route.query.product_id;
        // console.log(product_id);
        // getProductDetail(this.$route.query.product_id)
        getProducts(1,1,this.$route.query.product_id)
        .then(res=>{
            if(res.header.code==200){
                this.img = res.body.product.imgs[0].img;
                this.title = res.body.product.title;
                this.dara_productCode = res.body.product.dara_productCode;
                this.action_list(this.isActive,res.body.product.dara_productCode);
            }
        })
    },
    computed:{
        
    },
    mounted() {
        
    },
    methods: {
        tableChange_1(pagination){
            console.log(pagination);
            this.pagination_1.current=pagination.current;
            if(pagination.current >0 && pagination.current < (pagination.total/pagination.pageSize)){
                this.pagination_2.current=pagination.current+1;
            }
        },
        tableChange_2(pagination){
            console.log(pagination);
            this.pagination_2.current=pagination.current;
            if(pagination.current >1 && pagination.current <= (pagination.total/pagination.pageSize)){
                this.pagination_1.current=pagination.current-1;
            }
        },
        action_tab(event,type){
            // console.log(event);
            console.log(type);
            this.isActive = type;
            // this.action_list(this.isActive,this.dara_productCode);
        },
        action_list(type,dara_productCode){
            if(type == 'eBay'){
                getEBadyProductSalesSummary({product_code:dara_productCode}).then(res=>{
                    
                });
            }else{
                getProductSalesSummary(type,dara_productCode)
                .then(res=>{
                    // var res = {"header":{"code":200,"msg":"","inTime":"2021-06-28 10:20:02","outTime":"2021-06-28 10:20:02"},"body":{"sales":[{"currency":"AUD","itemId":"113747330016","ebayAccount":"homedecoraddd","is_active":"0","quantitySold":"1","hitCount":"146","startDate":"2019-05-13","endDate":"2021-03-11","viewItemUrl":"http:\/\/www.ebay.com\/itm\/113747330016","minPriceVariation":"11.39","maxPriceVariation":"11.39"},{"currency":"GBP","itemId":"114284857903","ebayAccount":"homedecoraddd","is_active":"0","quantitySold":"1","hitCount":"205","startDate":"2020-07-01","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/114284857903","minPriceVariation":"3.66","maxPriceVariation":"3.66"},{"currency":"USD","itemId":"124315545748","ebayAccount":"choiceonca","is_active":"0","quantitySold":"0","hitCount":"66","startDate":"2020-08-28","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/124315545748","minPriceVariation":"7.90","maxPriceVariation":"7.90"},{"currency":"USD","itemId":"184348227980","ebayAccount":"abelshoppiing","is_active":"0","quantitySold":"0","hitCount":"143","startDate":"2020-07-01","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/184348227980","minPriceVariation":"7.90","maxPriceVariation":"7.90"},{"currency":"USD","itemId":"192648936967","ebayAccount":"anjoycsa","is_active":"0","quantitySold":"0","hitCount":"41","startDate":"2018-09-06","endDate":"2018-12-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/192648936967","minPriceVariation":"7.45","maxPriceVariation":"7.45"},{"currency":"USD","itemId":"203054642146","ebayAccount":"anjoycsa","is_active":"0","quantitySold":"0","hitCount":"64","startDate":"2020-07-21","endDate":"2020-09-28","viewItemUrl":"http:\/\/www.ebay.com\/itm\/203054642146","minPriceVariation":"6.47","maxPriceVariation":"6.47"},{"currency":"USD","itemId":"203119788146","ebayAccount":"anjoycsa","is_active":"0","quantitySold":"0","hitCount":"14","startDate":"2020-09-28","endDate":"2020-10-05","viewItemUrl":"https:\/\/www.ebay.com\/itm\/1-x-Universal-Electrical-Cable-Twist-Quick-Connector-Wire-Stripper-DRILL-BIT-\/203119788146","minPriceVariation":"6.47","maxPriceVariation":"6.47"},{"currency":"USD","itemId":"223514147761","ebayAccount":"hkspringmall","is_active":"0","quantitySold":"3","hitCount":"805","startDate":"2019-05-13","endDate":"2021-04-01","viewItemUrl":"http:\/\/www.ebay.com\/itm\/223514147761","minPriceVariation":"7.76","maxPriceVariation":"7.76"},{"currency":"USD","itemId":"254223124201","ebayAccount":"forallabel","is_active":"0","quantitySold":"29","hitCount":"1222","startDate":"2019-05-07","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/254223124201","minPriceVariation":"6.88","maxPriceVariation":"6.88"},{"currency":"AUD","itemId":"254229831164","ebayAccount":"ladieswind11","is_active":"0","quantitySold":"2","hitCount":"179","startDate":"2019-05-13","endDate":"2020-06-13","viewItemUrl":"http:\/\/www.ebay.com\/itm\/254229831164","minPriceVariation":"11.18","maxPriceVariation":"11.18"},{"currency":"AUD","itemId":"254646480797","ebayAccount":"ladieswind11","is_active":"0","quantitySold":"0","hitCount":"53","startDate":"2020-07-07","endDate":"2021-01-05","viewItemUrl":"https:\/\/www.ebay.com\/itm\/Universal-Electrical-Drill-Bit-Cable-Quick-Connector-And-Stripper-4-6-Square-\/254646480797","minPriceVariation":"11.44","maxPriceVariation":"11.44"},{"currency":"USD","itemId":"263920545093","ebayAccount":"top.electronics","is_active":"1","quantitySold":"7","hitCount":"2545","startDate":"2018-09-06","endDate":null,"viewItemUrl":"http:\/\/www.ebay.com\/itm\/263920545093","minPriceVariation":"7.91","maxPriceVariation":"7.91"},{"currency":"USD","itemId":"263920546878","ebayAccount":"itelectronichk","is_active":"1","quantitySold":"221","hitCount":"10266","startDate":"2018-09-06","endDate":null,"viewItemUrl":"http:\/\/www.ebay.com\/itm\/263920546878","minPriceVariation":"7.91","maxPriceVariation":"7.91"},{"currency":"USD","itemId":"264038847239","ebayAccount":"itelectronichk","is_active":"0","quantitySold":"0","hitCount":"23","startDate":"2018-11-14","endDate":"2018-11-19","viewItemUrl":"https:\/\/www.ebay.com\/itm\/Universal-Electrical-Cable-Twist-Quick-Connector-Drill-Bit-Wire-Stripper-Tool-\/264038847239","minPriceVariation":"7.38","maxPriceVariation":"7.38"},{"currency":"USD","itemId":"273844155378","ebayAccount":"newbaraoutlet","is_active":"0","quantitySold":"31","hitCount":"1239","startDate":"2019-05-13","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/273844155378","minPriceVariation":"7.88","maxPriceVariation":"7.88"},{"currency":"USD","itemId":"303667535957","ebayAccount":"abelshopoutlet","is_active":"0","quantitySold":"0","hitCount":"95","startDate":"2020-08-28","endDate":"2020-12-10","viewItemUrl":"http:\/\/www.ebay.com\/itm\/303667535957","minPriceVariation":"6.89","maxPriceVariation":"6.89"},{"currency":"USD","itemId":"313198776957","ebayAccount":"lilysupermall","is_active":"0","quantitySold":"0","hitCount":"58","startDate":"2020-08-28","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/313198776957","minPriceVariation":"7.88","maxPriceVariation":"7.88"},{"currency":"USD","itemId":"333186176065","ebayAccount":"luckysupermarket","is_active":"0","quantitySold":"9","hitCount":"452","startDate":"2019-05-07","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/333186176065","minPriceVariation":"7.93","maxPriceVariation":"7.93"},{"currency":"USD","itemId":"352454946111","ebayAccount":"able_ce","is_active":"0","quantitySold":"23","hitCount":"693","startDate":"2018-09-06","endDate":"2019-04-04","viewItemUrl":"http:\/\/www.ebay.com\/itm\/352454946111","minPriceVariation":"2.49","maxPriceVariation":"2.49"},{"currency":"USD","itemId":"352658021205","ebayAccount":"able_ce","is_active":"0","quantitySold":"0","hitCount":"49","startDate":"2019-05-07","endDate":"2019-10-10","viewItemUrl":"http:\/\/www.ebay.com\/itm\/352658021205","minPriceVariation":"4.06","maxPriceVariation":"4.06"},{"currency":"USD","itemId":"353184120933","ebayAccount":"ladieswind11","is_active":"0","quantitySold":"0","hitCount":"74","startDate":"2020-08-28","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/353184120933","minPriceVariation":"7.88","maxPriceVariation":"7.88"},{"currency":"USD","itemId":"353184131801","ebayAccount":"ablehappyshop","is_active":"0","quantitySold":"0","hitCount":"70","startDate":"2020-08-28","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/353184131801","minPriceVariation":"7.88","maxPriceVariation":"7.88"},{"currency":"GBP","itemId":"362642875938","ebayAccount":"phoneworldwholesale","is_active":"0","quantitySold":"3","hitCount":"174","startDate":"2019-05-07","endDate":"2019-12-07","viewItemUrl":"http:\/\/www.ebay.com\/itm\/362642875938","minPriceVariation":"3.36","maxPriceVariation":"3.36"},{"currency":"USD","itemId":"373088071844","ebayAccount":"tseki29","is_active":"0","quantitySold":"0","hitCount":"66","startDate":"2020-06-19","endDate":"2020-11-12","viewItemUrl":"http:\/\/www.ebay.com\/itm\/373088071844","minPriceVariation":"6.89","maxPriceVariation":"6.89"},{"currency":"USD","itemId":"373175251743","ebayAccount":"abelsuperoutlet","is_active":"0","quantitySold":"0","hitCount":"97","startDate":"2020-08-28","endDate":"2021-01-05","viewItemUrl":"http:\/\/www.ebay.com\/itm\/373175251743","minPriceVariation":"7.88","maxPriceVariation":"7.88"},{"currency":"USD","itemId":"382950859032","ebayAccount":"ablehappyshop","is_active":"0","quantitySold":"1","hitCount":"138","startDate":"2019-05-13","endDate":"2019-12-13","viewItemUrl":"http:\/\/www.ebay.com\/itm\/382950859032","minPriceVariation":"4.06","maxPriceVariation":"4.06"},{"currency":"USD","itemId":"383210128927","ebayAccount":"able_ce","is_active":"0","quantitySold":"0","hitCount":"78","startDate":"2019-10-14","endDate":"2021-01-05","viewItemUrl":"https:\/\/www.ebay.com\/itm\/Universal-connector-Electrical-Drill-Bit-Cable-Quick-And-Stripper-4-6-Square-\/383210128927","minPriceVariation":"7.88","maxPriceVariation":"7.88"}]}};
                    console.log(res);
                    var tem = [];
                    if(res.header.code==200){
                        for(var i=0;i<res.body.sales.length;i++){
                                tem.push({
                                    hitCount:res.body.sales[i]['hitCount'],
                                    quantitySold:res.body.sales[i]['quantitySold'],
                                    account:[res.body.sales[i]['ebayAccount'],res.body.sales[i]['viewItemUrl']],
                                    startDate:res.body.sales[i]['startDate'],
                                    // str5:['['+res.body.sales[i]['minPriceVariation']+' '+res.body.sales[i]['currency']+' - '+res.body.sales[i]['maxPriceVariation']+' '+res.body.sales[i]['currency']+']', '[  |  ]'],
                                    str5:['['+res.body.sales[i]['minPriceVariation']+' '+res.body.sales[i]['currency']+' - '+res.body.sales[i]['maxPriceVariation']+' '+res.body.sales[i]['currency']+']'],
                                });
                        }
                        this.data_1 = tem;
                        // this.data_1 = res.body.sales;
                        // this.data_2 = res.body.sales;
                        this.pagination_1.total = res.body.sales.length;
                    }
                });
            }
        }
    },
};
</script>

<style  scoped>
.str1,.str2{
    display: block;
    height: 25px;
    color: white;
    border-radius: 30px;
    text-align: center;
    line-height: 25px;
    max-width: 50px;
}
.str1{
    background-color: black;
}
.str2{
    background-color: red;
}
.line_div{
    width:100%;
    height:5px;
}
.item_span{
    color: black;
    font-weight: 600;
}
</style>